import { useCallback } from 'react';
import { useConfigInputs, useConfigActions, useVendorCtx } from 'shared/state/configContexts';
import { directorMinFor } from 'shared/lib/vendorCaps';
import type { SectionStatus } from 'shared/state/sectionStatusContext';

export function useDirectorsSection() {
  const { config } = useConfigInputs();
  const { updateConfig } = useConfigActions();
  const { vendor } = useVendorCtx();
  const min = directorMinFor(vendor.capabilities as Record<string, unknown>, config.systemType);
  const status: SectionStatus = config.veloCount < min ? 'warn' : 'ok';

  return {
    count: config.veloCount,
    min,
    onCommit: useCallback((veloCount: number) => updateConfig({ veloCount }), [updateConfig]),
    summary: `${config.veloCount} D-nodes`,
    status,
  };
}
